import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    CreateAWorkspaceHeading,
    CreateAWorkspaceText,
    Headings,
    SubHeading
} from "../../../components";

export const NewUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    const confluenceWorkspaceText = (
        <FormattedMessage
            id="BxpUiSignup.nameSite.subHeader.newWorkspaceSubHeader"
            defaultMessage="This is the URL for your team to access Confluence. Most people use their team or company name."
        />
    );

    return (
        <FeatureExposed
            experimentKey="cfind-3467-signup-with-image-overlay"
            group="isTreatment"
        >
            <ConfluenceOverlayTemplate size="sm">
                <div
                    css={[
                        !team26VisualUpdates && headerOffsetForBlueBackgroundCss
                    ]}
                >
                    {team26VisualUpdates ? (
                        <Headings
                            main={<CreateAWorkspaceText />}
                            sub={confluenceWorkspaceText}
                        />
                    ) : (
                        <>
                            <CreateAWorkspaceHeading />
                            <SubHeading>{confluenceWorkspaceText}</SubHeading>
                        </>
                    )}
                </div>
                <SiteActivation useContactExpandCohortLogic={true} />
            </ConfluenceOverlayTemplate>
        </FeatureExposed>
    );
};

const headerOffsetForBlueBackgroundCss = css({
    marginBlockStart: 54,
    [media.above.sm]: {
        marginBlockStart: 0
    }
});
